package devxertech.com.utils

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier

// Source dimensions reserve space without changing the existing CSS sizing.
private val localImageSizes = mapOf(
    "blog.svg" to (726 to 704),
    "blog-header-2.svg" to (750 to 669),
    "chatbot_header.svg" to (717 to 717),
    "DevOps.svg" to (1428 to 1434),
    "ai_development_header.svg" to (680 to 734),
    "MobAppHeader.svg" to (781 to 750),
    "service_header.svg" to (796 to 701),
    "safe_desposit_portfolio.svg" to (345 to 220),
    "zone360_portfolio.svg" to (356 to 217),
    "test-2.jpg" to (320 to 256),
    "test-4.jpg" to (320 to 448),
    "modern.png" to (320 to 448),
)

internal fun imageDimensions(src: String): Pair<Int, Int>? {
    val name = src.substringBefore('?').substringAfterLast('/')
    localImageSizes[name]?.let { return it }
    // Sanity includes original dimensions in its image asset filenames.
    val match = Regex("-(\\d+)x(\\d+)\\.[^.]+$").find(name) ?: return null
    return match.groupValues[1].toInt() to match.groupValues[2].toInt()
}

internal fun sanityImageSrcSet(src: String): String? {
    if (!src.startsWith("https://cdn.sanity.io/images/") || src.substringBefore('?').endsWith(".svg")) return null
    val originalWidth = imageDimensions(src)?.first ?: return null
    val widths = (listOf(320, 640, 960, 1440, 1920).filter { it < originalWidth } + minOf(originalWidth, 1920)).distinct()
    val separator = if ('?' in src) "&" else "?"
    return widths.joinToString(", ") { "$src${separator}auto=format&fit=max&w=$it ${it}w" }
}

internal fun Modifier.imageLoading(
    src: String,
    lazy: Boolean = false,
    highPriority: Boolean = false,
    sizes: String = "100vw",
): Modifier = attrsModifier {
    imageDimensions(src)?.let { (width, height) ->
        attr("width", width.toString())
        attr("height", height.toString())
    }
    attr("loading", if (lazy) "lazy" else "eager")
    attr("decoding", "async")
    if (highPriority) attr("fetchpriority", "high")
    sanityImageSrcSet(src)?.let {
        attr("srcset", it)
        attr("sizes", sizes)
    }
}
